app.component("searchDashboard", {
	templateUrl: "app/src/js/components/searchDashboard/searchDashboard.html",
	controller: "searchDashboardController",
	bindings: {
		reload: "=",
	},
});

app.controller("searchDashboardController", [
	"$scope",
	"CurrentReferral",
	"ReferralsAPI",
	"NHI",
	"filterFilter",
	"$timeout",
	"Session",
	"$rootScope",
	"PatientAPI",
	"$modal",
	"CurrentPatient",
	"$state",
	"NHISearchPatientsAPI",
	"PlaceAPI",
	"NgTableParams",
	"NHI_SERVICE_ERROR",
	"countryConfig",
	"CONFIG",
	"$mdDialog",
	"$stateParams",
	"NHI_VERSION_V2",
	"PatientImportReview",
	function (
		$scope,
		CurrentReferral,
		ReferralsAPI,
		NHI,
		filterFilter,
		$timeout,
		Session,
		$rootScope,
		PatientAPI,
		$modal,
		CurrentPatient,
		$state,
		NHISearchPatientsAPI,
		PlaceAPI,
		NgTableParams,
		NHI_SERVICE_ERROR,
		countryConfig,
		CONFIG,
		$mdDialog,
		$stateParams,
		NHI_VERSION_V2,
		PatientImportReview
	) {
		$scope.PA = PatientAPI;
		$scope.CP = CurrentPatient;
		$scope.CR = CurrentReferral;
		$scope.RA = ReferralsAPI;
		$scope.NHIAPI = NHISearchPatientsAPI;
		$scope.PlaceAPI = PlaceAPI;
		$scope.Session = Session;
		$scope.formData = {};
		$scope.CPIdx;
		$rootScope.selectedPatient = {};
		$scope.showingDate = {};
		$scope.display = {};
		$scope.display.address = {};
		$scope.addressError = false;
		$scope.regionWarningHasBeenShownOnce = false;
		$scope.currentYear = new Date().getFullYear();
		$scope.hideSaveButton = false;
		$scope.userIsPracticeAdmin = false;
		$scope.optionalPatients = [];
		$scope.isNHIFeatureEnabled = false;
		$scope.favoritePatientList = [];
		$scope.showWorkupButton = false;
		$scope.CALENDAR_ENABLE = false;
		$scope.countryConfig = countryConfig;
		$scope.isTaskFeatureEnabled = Session.practice.practiceFeatures.sendTasksWithinPracticeFeature;
		$scope.lastSearchWasAdvanced = false;

		this.$onInit = function () {
			angular.element(document.querySelector("#lastName")).focus();
			$scope.NHI_VERSION_V2 = NHI_VERSION_V2;
			$scope.fhirNhiFeature = Session.practice.practiceFeatures.fhirNhiFeature;
			$scope.legacyTable = false;
			$scope.isFullSearch = true;
		};

		$scope.toggleFullSearch = function () {
			$scope.isFullSearch = true;
			// A leftover NHI would otherwise take precedence over the name search in fetchNHIPatients.
			$scope.formData.nhi = '';
			$scope.invalidNhiSearch = false;
		}

		$scope.clearInvalidNhiSearch = function () {
			$scope.invalidNhiSearch = false;
		}

		$scope.toggleNHISearch = function () {
			$scope.isFullSearch = false;
			$scope.formData = {
				lastName: '',
				middleName: '',
				firstName: '',
				DD: '',
				MM: '',
				YYYY: '',
				terms: '',
				nhi: ''
			};
		}

		if (Session.practice.practiceFeatures && Session.practice.practiceFeatures.calendarFeature === true) {
			$scope.CALENDAR_ENABLE = true;
		}

		$scope.createTask = function (event, patient) {
			event.preventDefault();
			event.stopPropagation();

			// A task can't be added to an imported patient until it is reviewed. Review it first, then give the
			// task to the patient it turns out to be - the existing patient, when it was a duplicate.
			if (patient.needs_review) {
				PatientImportReview.open(patient.id).then(showTaskDialog).catch(angular.noop);
				return;
			}
			showTaskDialog(patient);
		};

		function showTaskDialog(patient) {
			$mdDialog.show({
				controller: "createTaskController",
				templateUrl: "app/src/views/templates/create-task.tmpl.html",
				parent: angular.element(document.body),
				clickOutsideToClose: false,
				scope: $scope.$new(true),
				preserveScope: false,
				resolve: {
					// accounts: () => $scope.accounts,
					patientName: () => patient.firstName + ' ' + patient.lastName,
					dob: () => patient.dateOfBirth,
					patientId: () => patient.id,
					taskList: () => false,
					createNewTask: () => null,
					updateBadge: () => null,
					fetchTask: () => null,
					defaultAssigner: () => null,
				},
			});
		}

		$scope.clickCalendar = function (event, patient) {
			event.preventDefault();
			event.stopPropagation();
			// $scope.loaded = false;
			$mdDialog
				.show({
					controller: 'calendarController',
					templateUrl: "app/src/views/templates/calendar.tmpl.html",
					// Appending dialog to document.body to cover sidenav in docs app
					// Modal dialogs should fully cover application to prevent interaction outside of dialog
					parent: angular.element(document.body),
					targetEvent: event,
					clickOutsideToClose: false,
					openFrom: "#anchor",
					closeTo: "#anchor",
					scope: $scope.$new(true),
					preserveScope: false,
					// onComplete: () => ($scope.loaded = true),
					// onRemoving: () => ($scope.loaded = false),
					resolve: {
						patientId: () => patient.id,
						patientName: () => patient.firstName + ' ' + patient.lastName,
						selectedAppointment: () => null
					}
				})
				.then(
					function (answer) {
						//� �$scope.status = 'You said the information was "' + answer + '".';
					},
					function () {
						//� �$scope.status = 'You cancelled the dialog.';
					}
				);
		}

		if ($scope.Session.user.features && $scope.Session.user.features.favoritePatientsFeature) {
			$scope.favoritePatientList = $scope.Session.user.features.favoritePatientsFeature;
		}

		if (
			Session.practice.practiceFeatures &&
			(Session.practice.practiceFeatures.nhiFeature === true || Session.practice.practiceFeatures.fhirNhiFeature === true)
		) {
			$scope.isNHIFeatureEnabled = true;
		}

		$scope.popoverDormantNHI = function (obj) {
			return {
				title: 'Dormant NHI',
				content:
					obj.dormantIdentifiers.join(),
			};
		}

		// Clear Session values for CurrentPatient and Current Referral


		$scope.showWorkupButton = Session.canStartWorkup();

		if ($scope.CP.patients.length > 0 && $scope.CP.query) {
			$timeout(function () {
				$scope.formData = {
					lastName: $scope.CP.query.lastName,
					DD: $scope.CP.query.DD,
					MM: $scope.CP.query.MM,
					YYYY: $scope.CP.query.YYYY,
					terms: $scope.CP.query.terms,
				};
				$scope.searchResults = $scope.CP.patients.map(t => ({ ...t, practiceId: t.practice.id }));
				if ($scope.formData.terms) {
					$scope.advanced_search && $scope.advanced_search.$setSubmitted();
				} else {
					$scope.basic_search && $scope.basic_search.$setSubmitted();
				}

				$scope.practiceFilter = $scope.searchResults.reduce(function (accumulator, currentValue) {
					if (!accumulator.some(t => t.title === currentValue.practice.name)) {
						accumulator.push({ id: currentValue.practice.id, title: currentValue.practice.name })
					}
					return accumulator
				}, [{ id: '', title: 'All' }])
				$scope.tableParams = new NgTableParams({
					count: 20
				}, {
					counts: [],
					// filterOptions: { filterComparator: applyComparer },
					dataset: $scope.searchResults,
				});
				// const index = $scope.searchResults.findIndex(t => t.id === $scope.CP.patient.id)
				// $scope.selectPatient($scope.searchResults[0], 0);
			}, 0);
		} else {
			// if(!$stateParams.isFromCalendar){
			$scope.CP.clearPatient();
			$scope.CR.clearReferral();
			// }
		}

		function fetchCattraxPatients() {
			let dob = '';
			if ($scope.formData.YYYY && $scope.formData.MM && $scope.formData.DD) {
				dob = $scope.formData.YYYY + "/" + $scope.formData.MM + "/" + $scope.formData.DD;
			}
			let endpoint;
			if (dob && $scope.formData.lastName) {
				endpoint = $scope.PA.search($scope.formData.lastName, dob, '', '')
			} else if ($scope.formData.nhi) {
				endpoint = $scope.PA.search('', '', '', $scope.formData.nhi)
			}
			if (endpoint) {
				$scope.PA.isProcessing = true;
				endpoint.then(function (resp) {
					if (resp.data.length === 0) {
						$scope.isAdvancedSearch = true;
						$scope.fetchNHIPatients();
					} else {
						$scope.searchResults = resp.data.map(t => ({ ...t, practiceId: t.practice.id }));
						$scope.practiceFilter = $scope.searchResults.reduce(function (accumulator, currentValue) {
							if (!accumulator.some(t => t.title === currentValue.practice.name)) {
								accumulator.push({ id: currentValue.practice.id, title: currentValue.practice.name })
							}
							return accumulator
						}, [{ id: '', title: 'All' }])

						$scope.tableParams = new NgTableParams({
							count: 20
						}, {
							counts: [],
							// filterOptions: { filterComparator: applyComparer },
							dataset: $scope.searchResults,
						});
						$scope.CP.setPatientResult(resp.data, $scope.formData);
					}
				}, function (error) {
					console.error(error && error.status);
				}).then(function () {
					$scope.PA.isProcessing = false;
				})
			}
		}

		$scope.fetchNHIPatients = function () {
			if (!$scope.isNHIFeatureEnabled) {
				return;
			}
			$scope.NHIAPI.isProcessing = true;
			let dob = '';
			if ($scope.formData.YYYY && $scope.formData.MM && $scope.formData.DD) {
				dob = $scope.formData.YYYY + "/" + $scope.formData.MM + "/" + $scope.formData.DD;
			}
			var lastName = $scope.formData.lastName;
			$scope.advanced_search && $scope.advanced_search.$setPristine();
			$scope.formData.terms = '';

			let endpoint;

			if ($scope.formData.nhi) {
				endpoint = $scope.NHIAPI.searchAllNHIPatientsV2($scope.formData.nhi)
			} else {
				endpoint = $scope.NHIAPI.queryPatientsV2(lastName, dob, $scope.formData.firstName, $scope.formData.middleName)
			}


			endpoint.then(
				function (resp) {
					let data = resp.data;
					// The API returns 204/an empty list when the NHI service has no match -
					// show the modal's empty state rather than treating it as a failure.
					if (!data) {
						data = [];
					} else if (!Array.isArray(data)) {
						data = [data];
					}
					$scope.optionalPatients = data.map(t => ({
						...t,
						firstName: (t.names && t.names[0] || {}).firstName,
						middleName: (t.names && t.names[0] || {}).middleName,
						lastName: (t.names && t.names[0] || {}).lastName,
						expanded: false,
						codedEthnicities: angular.copy(t.ethnicities)
						// practiceId: t.practice.id
					}))
					$scope.tableOptionalPatientsParams = new NgTableParams({
						count: 20
					}, {
						counts: [],
						dataset: $scope.optionalPatients
					});
					modalForNHI();

				},
				function (err) {
					console.log(err && err.status);
					$scope.alertMessage = NHI_SERVICE_ERROR.body;
					$scope.serverErrorModal = $modal({
						scope: $scope,
						templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
						show: true,
						title: NHI_SERVICE_ERROR.title,
					});
				}
			).then(function () {
				$scope.NHIAPI.isProcessing = false;
				$scope.PA.isProcessing = false;
			})
		}

		$scope.isAdvancedSearch = false;

		$scope.onBasicSubmit = function () {
			// Don't send anything that isn't a well-formed NHI to the NHI lookup - the value is used as a URL path segment.
			$scope.invalidNhiSearch = !$scope.isFullSearch && NHI.validate(($scope.formData.nhi || '').trim()) !== true;
			if ($scope.invalidNhiSearch) {
				return;
			}
			if (!$scope.isFullSearch) {
				$scope.formData.nhi = $scope.formData.nhi.trim().toUpperCase();
			}
			$scope.lastSearchWasAdvanced = false;
			$scope.searchResults = [];
			$scope.isAdvancedSearch = false;
			$scope.formData.terms = '';
			$scope.advanced_search.$setPristine();
			fetchCattraxPatients();
		}

		$scope.onAdvancedSubmit = function () {
			$scope.lastSearchWasAdvanced = true;
			$scope.isAdvancedSearch = true;
			$scope.PA.isProcessing = true;
			$scope.basic_search && $scope.basic_search.$setPristine();
			let searchTerms = $scope.formData.terms;
			$scope.formData.firstName = '';
			$scope.formData.lastName = '';
			$scope.formData.middleName = '';
			$scope.formData.DD = '';
			$scope.formData.MM = '';
			$scope.formData.YYYY = '';
			$scope.searchResults = [];

			$scope.PA.search('', '', searchTerms, '')
				.then(
					function (resp) {
						$scope.searchResults = resp.data.map(t => ({ ...t, practiceId: t.practice.id }));
						$scope.practiceFilter = $scope.searchResults.reduce(function (accumulator, currentValue) {
							if (!accumulator.some(t => t.title === currentValue.practice.name)) {
								accumulator.push({ id: currentValue.practice.id, title: currentValue.practice.name })
							}
							return accumulator
						}, [{ id: '', title: 'All' }])

						$scope.tableParams = new NgTableParams({
							count: 20
						}, {
							counts: [],
							// filterOptions: { filterComparator: applyComparer },
							dataset: $scope.searchResults,
						});
						$scope.CP.setPatientResult(resp.data, $scope.formData);
						// if($scope.searchResults.length === 0 && $scope.isNHIFeatureEnabled){
						// 	$scope.showCreateModalV2();
						// }
					},
					function (err) {
						console.log(err && err.status);
					}
				)
				.then(function () {
					$scope.PA.isProcessing = false;
				});
		}

		$scope.resetSearch = function () {
			$scope.advanced_search && $scope.advanced_search.$setPristine();
			$scope.basic_search && $scope.basic_search.$setPristine();
			$scope.formData = {};
			$scope.invalidNhiSearch = false;
			$scope.searchResults = [];
			$scope.CP.clearPatientResult();
		};

		$scope.isFormEmpty = function () {
			if ($scope.formData.lastName || $scope.formData.terms || $scope.formData.terms) {
				return false;
			} else if ($scope.formData.DD && $scope.formData.MM && $scope.formData.YYYY) {
				return false;
			}
			return true;
		}

		$scope.selectPatient = function (patient, idx) {
			$scope.regionWarningHasBeenShownOnce = false;
			$scope.CPIdx = idx;
			$scope.CP.setPatient(patient);

			if (!$scope.CP.patientIsMine) {
				$modal({
					controller: "patientTransferController",
					templateUrl: "app/src/views/templates/modal.patient-transfer-flow.tpl.html",
					show: true,
					backdrop: "static",
					resolve: {
						patientId: function () {
							return patient.id;
						},
						// Pass a callback to update the dashboard when transfer succeeds
						onSuccess: function () {
							return function (updatedPatient) {
								$scope.CP.setPatient(updatedPatient);
								// idx is the row on the current ng-table page, not the index into searchResults.
								const resultIdx = $scope.searchResults.findIndex(t => t.id === patient.id);
								if (resultIdx !== -1) {
									$scope.searchResults[resultIdx] = { ...updatedPatient, practiceId: updatedPatient.practice && updatedPatient.practice.id };
									if ($scope.tableParams) {
										$scope.tableParams.reload();
									}
								}
							};
						},
						onCancel: function () {
							return function () { };
						}
					}
				});
			}
		};

		// angular-strap modal close for unknown reason mutates $scope.CP.patient.smokerAnswer to null value when modal is closed
		$scope.showEditModal = function () {
			if ($scope.patientDetailsModal) {
				$scope.patientDetailsModal.hide();
			}
			var smokingValue = $scope.CP.patient.smokerAnswer;
			$scope.editModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.edit.tpl.html",
				show: true,
				title: "EDIT PATIENT DETAILS",
				onHide: function () {
					$scope.CP.patient.smokerAnswer = smokingValue;
				},
			});
		};

		// When close the 'edit patient modal' if the data has been changed but not sent to the
		// server, this will refresh the patient object with clean data from the server
		$scope.closeEditModal = function () {
			// $scope.editModal.hide();
		};

		$scope.showCreateModal = function () {
			var newSmokingValue;
			// resetFormExtras();
			$scope.CP.clearPatient();
			$scope.addressError = false;
			$scope.hideSaveButton = false;
			if (typeof $scope.formData.lastName === "string") {
				$scope.showingDate.DD = $scope.formData.DD;
				$scope.showingDate.MM = $scope.formData.MM;
				$scope.showingDate.YYYY = $scope.formData.YYYY;
				$scope.CP.patient.lastName = titleCase($scope.formData.lastName);
				$scope.CP.patient.dateOfBirth = makeDateString();
			}
			$scope.CP.createNewPatient();
		};

		$scope.selectOptionalPatient = function (patient, index) {
			$scope.optionalPatients.forEach(function (val) {
				val.expanded = false;
			})
			patient.expanded = true;
		}

		$scope.createNewPatientUI = function () {
			if ($scope.patientsOptionalModal) {
				$scope.patientsOptionalModal.hide();
			}
			$scope.CP.createNewPatient();
		}

		function formatAddress(address) {
			let formattedAddress = '';
			if (address.streetAddress) {
				formattedAddress += address.streetAddress + ',';
			}
			if (address.suburb) {
				formattedAddress += address.suburb + ',';
			}
			if (address.city) {
				formattedAddress += address.city;
			}
			return formattedAddress
		}

		function formatAddressPostCode(address) {
			let formattedAddress = '';
			if (address.streetAddress) {
				formattedAddress += address.streetAddress + ',';
			}
			if (address.suburb) {
				formattedAddress += address.suburb + ',';
			}
			if (address.city) {
				formattedAddress += address.city + ',';
			}
			if (address.postCode) {
				formattedAddress += address.postCode;
			}
			return formattedAddress
		}

		function extractApartmentNumber(addressObj) {
			const streetAddress = addressObj.streetAddress
			if (streetAddress.includes('/')) {
				addressObj.streetAddress = streetAddress.split('/')[1];
				addressObj.apartmentNumber = streetAddress.split('/')[0];
			}
		}

		$scope.presetPatient = function (patient) {
			$scope.showingDate.DD = patient.dateOfBirth.substr(8, 2);
			$scope.showingDate.MM = patient.dateOfBirth.substr(5, 2);
			$scope.showingDate.YYYY = patient.dateOfBirth.substr(0, 4);
			$scope.CP.patient.lastName = patient.names[0].lastName;
			$scope.CP.patient.dateOfBirth = makeDateString();
			$scope.CP.patient.firstName = patient.names[0].firstName;
			$scope.CP.patient.nhi = patient.nhi;
			$scope.CP.patient.gender = $scope.NHIAPI.transformGenderProp(patient.gender);
			$scope.CP.patient.isResident = patient.isResident;
			if (patient.contacts && patient.contacts.length > 0) {
				if (!patient.contacts[0].confidentialInformation) {
					$scope.CP.patient.phoneNumber = patient.contacts[0].phoneNumber
				}
			}
			if (CONFIG.NHI_ADDRESS && patient.addresses && patient.addresses.length > 0) {
				$scope.CP.patient.addresses = [{}];
				const address = patient.addresses[0];
				extractApartmentNumber(address);
				const add = formatAddressPostCode(address);

				$scope.PlaceAPI.getPlaceDetail(document.getElementById('hidden_address'), add, function (place) {
					if (place === null) {
						if ($scope.patientsOptionalModal) {
							$scope.patientsOptionalModal.hide();
						}
						$scope.CP.createNewPatientWithPreset();
						return;
					}
					$scope.CP.patient.addresses[0] = { type: "PHYSICAL", json: JSON.stringify(place) };
					$scope.CP.patient.addresses[0].line1 = place.formatted_address;
					$scope.CP.patient.addresses[0].apartmentNumber = address.apartmentNumber ? address.apartmentNumber : '';
					setTimeout(() => {
						if ($scope.patientsOptionalModal) {
							$scope.patientsOptionalModal.hide();
						}
						$scope.CP.createNewPatientWithPreset();
						$scope.$apply();
					}, 0);
				});
			} else {
				if ($scope.patientsOptionalModal) {
					$scope.patientsOptionalModal.hide();
				}
				$scope.CP.createNewPatientWithPreset();
			}

		}

		function composeDOB(dateOfBirth) {
			if ($scope.fhirNhiFeature) {
				$scope.showingDate.DD = parseInt(dateOfBirth[0]);
				$scope.showingDate.MM = parseInt(dateOfBirth[1]);
				$scope.showingDate.YYYY = parseInt(dateOfBirth[2]);
			} else {
				$scope.showingDate.DD = parseInt(dateOfBirth[2]);
				$scope.showingDate.MM = parseInt(dateOfBirth[1]);
				$scope.showingDate.YYYY = parseInt(dateOfBirth[0]);
			}
		}

		function getNZCitizenState(nzCitizen) {
			if (nzCitizen === 'YES') {
				return true;
			} else if (nzCitizen === 'NO') {
				return false;
			}
			return null;
		}

		$scope.addNextOfKin = function () {
			if (!$scope.CP.patient.nextOfKin) {
				$scope.CP.patient.nextOfKin = []
			}

			$scope.CP.patient.nextOfKin.push({
				kinName: ``,
				kinRelationship: ``,
				kinContactPhone: ``,
				kinContactEmail: ``
			});
		};

		$scope.removeNextOfKin = function (index) {
			$scope.CP.patient.nextOfKin.splice(index, 1)
		};

		$scope.presetPatientV2 = function (patient) {
			const dateOfBirth = patient.dob.split('-');
			composeDOB(dateOfBirth);
			$scope.CP.patient.lastName = patient.familyNameCol;
			$scope.CP.patient.dateOfBirth = makeDateStringV2();
			$scope.CP.patient.firstName = patient.firstNameCol;
			$scope.CP.patient.nhi = patient.nhiCol;
			$scope.CP.patient.gender = $scope.NHIAPI.transformGenderProp(patient.gender);
			$scope.CP.patient.isResident = getNZCitizenState(patient.nzCitizen);
			$scope.CP.patient.codedEthnicities = patient.codedEthnicities;


			// NOTE: THIS IS CALLED WHEN CREATING PATIENTS VIA NHI
			// TODO: This is commented out until we can test that this works. 
			// We don't have any test NHI's with NOK contact info to test on.
			//$scope.CP.patient.nextOfKin = (patient?.contacts || []).map((contact) => {

			//	// Safely access names with fallbacks to empty strings
			//	const preferedFirstName = contact?.contactName?.givenNameList?.[0] ?? '';
			//	const familyName = contact?.contactName?.familyName ?? '';

			//	// Safely access relationship text
			//	const relationship = contact?.contactRelationship?.[0]?.text ?? 'Unknown';

			//	// Use .find() safely and handle cases where the array or the specific system type doesn't exist
			//	const contactPhone = contact?.contactDetails?.find(cp => cp.system === 'Phone')?.value ?? "";
			//	const contactEmail = contact?.contactDetails?.find(cp => cp.system === 'Email')?.value ?? "";

			//	return {
			//		// Concatenate names, trimming in case one is missing to avoid leading/trailing spaces
			//		kinName: `${preferedFirstName} ${familyName}`.trim(),
			//		kinRelationship: relationship,
			//		kinContactPhone: contactPhone,
			//		kinContactEmail: contactEmail
			//	};
			//});

			
			// if (patient.contacts && patient.contacts.length > 0) {
			// 	if (!patient.contacts[0].confidentialInformation && patient.contacts[0].phoneNumber) {
			// 		$scope.CP.patient.phoneNumber = patient.contacts[0].phoneNumber;
			// 	}
			// }
			if (CONFIG.NHI_ADDRESS && patient.addresses && patient.addresses.length > 0) {
				$scope.CP.patient.addresses = [{}];
				let address = patient.addresses.find(t => t.addressType === 'PHYSICAL');

				if (!address) {
					address = patient.addresses[0];
				}

				if (address && !address.addressCountry && !address.overseas) {
					address.addressCountry = 'New Zealand';
				}
				// extractApartmentNumber(address);
				// const add = formatAddressPostCode(address);
				const add = address.addressLine.join(',') + ',' + address.addressCity + ',' + address.addressCountry + ',' + address.addressPostalCode;

				$scope.PlaceAPI.getPlaceDetail(document.getElementById('hidden_address'), add, function (place) {
					$scope.CP.patient.addresses[0] = { type: "PHYSICAL" };
					$scope.CP.patient.addresses[0].apartmentNumber = address.apartmentNumber ? address.apartmentNumber : '';

					/**
					 * The NHI address could not be matched to a place, so there is nothing to preset.
					 * Leave the address field empty for the user to select from the drop down instead
					 * of reading a formatted address off nothing.
					 */
					if (!isSelectedAddress(place)) {
						return;
					}

					$scope.display.address = angular.copy(place);
					$scope.display.apartmentNumber = $scope.CP.patient.addresses[0].apartmentNumber ? $scope.CP.patient.addresses[0].apartmentNumber : '';

					$scope.CP.patient.addresses[0].line1 = $scope.display.address.formatted_address;
					$scope.CP.patient.addresses[0].type = "PHYSICAL";
					($scope.CP.patient.addresses[0].line3 = null),
						($scope.CP.patient.addresses[0].line4 = null),
						($scope.CP.patient.addresses[0].apartmentNumber = $scope.display.apartmentNumber),
						($scope.CP.patient.addresses[0].json = JSON.stringify($scope.display.address));

					$scope.display.address.address_components.map(function (obj) {
						if (obj.types.indexOf("postal_code") !== -1) {
							$scope.CP.patient.addresses[0].postCode = obj.long_name;
						}
					});

					$scope.display.address.address_components.map(function (obj) {
						if (obj.types.indexOf("country") !== -1) {
							$scope.CP.patient.addresses[0].country = obj.long_name;
						}
					});

					$scope.display.address.address_components.map(function (obj) {
						if (obj.types.indexOf("locality") !== -1) {
							$scope.CP.patient.addresses[0].city = obj.long_name;
						}
					});

					$scope.display.address.address_components.map(function (obj) {
						if (obj.types.indexOf("sublocality") !== -1) {
							$scope.CP.patient.addresses[0].line2 = obj.long_name;
						}
					});

					setTimeout(() => {
						$scope.$apply();
					}, 0);

				});
			}
			if ($scope.patientsOptionalModal) {
				$scope.patientsOptionalModal.hide();
			}	
			$scope.CP.createNewPatientWithPreset();
		}

		function queryPatients(lastName, dateOfBirth) {
			return $scope.NHI_VERSION_V2 ? $scope.NHIAPI.queryPatientsV2(lastName, dateOfBirth) : $scope.NHIAPI.queryPatients(lastName, dateOfBirth);
		}

		function modalForNHI() {
			if ($scope.NHI_VERSION_V2) {
				$mdDialog.show({
					controller: "nhiRecordController",
					templateUrl: "app/src/views/templates/modal.select-patient-v2.tpl.html",
					parent: angular.element(document.body),
					clickOutsideToClose: false,
					scope: $scope.$new(true),
					preserveScope: false,
					resolve: {
						optionalPatients: () => $scope.optionalPatients,
						callback: () => (nhiObj) => $scope.presetPatientV2(nhiObj),
						skipAction: () => () => { $scope.showCreateModal() }
					},
				});
			} else {
				$scope.patientsOptionalModal = $modal({
					scope: $scope,
					templateUrl: "app/src/views/templates/modal.select-patient.tpl.html",
					show: true,
					title: "SUGGESTED PATIENTS FROM THE NHI SERVICE",
					backdrop: "static",
					keyboard: false,
					onHide: function () {
						//TODO
						// $scope.resetSearch();
					},
				});
			}
		}

		$scope.handleCreateNewPatient = function () {
			// If the last search was the simple keyword search...
			if ($scope.lastSearchWasAdvanced) {
				// ...call the simple create modal function which CANNOT contact NHI.
				$scope.showCreateModal();
			} else {
				// ...otherwise, it was the DOB/NHI search, so call the v2 modal
				// which CAN contact the NHI service.
				$scope.showCreateModalV2();
			}
		};

		$scope.showCreateModalV2 = function () {
			/**�
			if(!$scope.isNHIFeatureEnabled){
				$scope.showCreateModal();
				return;
			} */
			$scope.CP.clearPatient();
			$scope.hideSaveButton = false;
			if (typeof $scope.formData.lastName === "string") {
				$scope.showingDate.DD = $scope.formData.DD;
				$scope.showingDate.MM = $scope.formData.MM;
				$scope.showingDate.YYYY = $scope.formData.YYYY;
				$scope.CP.patient.lastName = titleCase($scope.formData.lastName);
				$scope.CP.patient.dateOfBirth = makeDateStringV2();
				$scope.PA.isProcessing = true;
				$scope.optionalPatients = [];
				$scope.clickedPatient = null;
				if (!$scope.countryConfig.nhiFeatureEnabled) {
					$scope.CP.createNewPatient();
					$scope.PA.isProcessing = false;
					return;
				} else {
					$scope.NHIAPI.isProcessing = true;
					queryPatients($scope.CP.patient.lastName, $scope.CP.patient.dateOfBirth)
						.then(
							function (resp) {
								// 204/no body when the NHI service has no match - same as an empty list.
								if (!resp.data || resp.data.length === 0) {
									$scope.CP.createNewPatient();
									return;
								}
								$scope.optionalPatients = resp.data.map(t => ({
									...t,
									firstName: (t.names && t.names[0] || {}).firstName,
									middleName: (t.names && t.names[0] || {}).middleName,
									lastName: (t.names && t.names[0] || {}).lastName,
									expanded: false,
									// practiceId: t.practice.id
								}))
								$scope.practiceFilter = $scope.searchResults.reduce(function (accumulator, currentValue) {
									if (!accumulator.some(t => t.title === currentValue.practice.name)) {
										accumulator.push({ id: currentValue.practice.id, title: currentValue.practice.name })
									}
									return accumulator
								}, [{ id: '', title: 'All' }])
								$scope.tableOptionalPatientsParams = new NgTableParams({
									count: 20
								}, {
									counts: [],
									dataset: $scope.optionalPatients
								});

								modalForNHI();
								// $scope.patientsOptionalModal = $modal({
								// 	scope: $scope,
								// 	templateUrl: modalTemplateUrl(),
								// 	show: true,
								// 	title: "SUGGESTED PATIENTS FROM THE NHI SERVICE",
								// 	backdrop: "static",
								// 	keyboard: false,
								// 	onHide: function () {
								// 		//TODO
								// 		// $scope.resetSearch();
								// 	},
								// });

							},
							function (err) {
								$scope.CP.createNewPatient();
							}
						).then(function () {
							$scope.NHIAPI.isProcessing = false;
							$scope.PA.isProcessing = false;
						})
				}
			}
			// $scope.CP.createNewPatient();
		};

		$scope.trimLongText = function (text) {
			if (text && text.length > 30) {
				return text.substring(0, 27) + "...";
			}
			return text;
		}


		function titleCase(str) {
			var splitStr = str.toLowerCase().split(" ");
			for (var i = 0; i < splitStr.length; i++) {
				splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
			}
			return splitStr.join(" ");
		}

		/**
		 * An address is only usable once it has been selected from the lookup drop down: that is
		 * what fills in the formatted address and the lat/lng the back end needs to resolve the
		 * patient's DHB. With force-selection the typed text never reaches the model, so the field
		 * can look filled in while the model is still the empty object it started as.
		 */
		function isSelectedAddress(address) {
			return !!(address && address.formatted_address && address.address_components
				&& address.geometry && address.geometry.location);
		}

		$scope.registerPatient = function () {
			if (!isSelectedAddress($scope.display.address)) {
				$scope.addressError = true;
				const addressInput = document.querySelector("#ct-address");
				if (addressInput) {
					addressInput.select();
				}
				return;
			}

			$scope.PA.isProcessing = true;
			$scope.CP.patient.practice = { id: Session.practice.id };
			$scope.CP.patient.dateOfBirth = makeDateString();
			$scope.CP.patient.ethnicities = $scope.selection;

			$scope.CP.patient.addresses = [{}];

			$scope.CP.patient.addresses[0].line1 = $scope.display.address.formatted_address;
			$scope.CP.patient.addresses[0].type = "PHYSICAL";
			($scope.CP.patient.addresses[0].line3 = null),
				($scope.CP.patient.addresses[0].line4 = null),
				($scope.CP.patient.addresses[0].apartmentNumber = $scope.display.apartmentNumber),
				($scope.CP.patient.addresses[0].json = JSON.stringify($scope.display.address));

			$scope.display.address.address_components.map(function (obj) {
				if (obj.types.indexOf("postal_code") !== -1) {
					$scope.CP.patient.addresses[0].postCode = obj.long_name;
				}
			});

			$scope.display.address.address_components.map(function (obj) {
				if (obj.types.indexOf("country") !== -1) {
					$scope.CP.patient.addresses[0].country = obj.long_name;
				}
			});

			$scope.display.address.address_components.map(function (obj) {
				if (obj.types.indexOf("locality") !== -1) {
					$scope.CP.patient.addresses[0].city = obj.long_name;
				}
			});

			$scope.display.address.address_components.map(function (obj) {
				if (obj.types.indexOf("sublocality") !== -1) {
					$scope.CP.patient.addresses[0].line2 = obj.long_name;
				}
			});

			$scope.removeEmptyStringValues();

			$scope.PA.create($scope.CP.patient)
				.then(
					function (resp) {
						$scope.CP.setPatient(resp.data);
					},
					function (err) {
						console.log(err && err.status);
						$scope.PA.isProcessing = false;

						/**
						 * The API rejects a NZ patient whose address was not selected from the lookup.
						 * The submit is already blocked before it gets that far, so this only catches a
						 * page that was open before the rule existed - point at the field either way.
						 */
						if (err.status === 400 || (err.data && err.data.status === 400)) {
							$scope.addressError = !isSelectedAddress($scope.display.address);
						}

						if (err.data && err.data.status === 409) {
							// close modal
							$scope.createModal.hide();
							// show error modal
							$scope.duplicateModal = $modal({
								scope: $scope,
								templateUrl: "app/src/views/templates/modal.duplicate-patient.tpl.html",
								show: true,
								title: "DUPLICATE PATIENT",
								backdrop: "static",
								keyboard: false,
								onHide: function () {
									$scope.resetSearch();
								},
							});
						}
						throw new Error("failed to create patient");
					}
				)
				.then(function (obj) {
					$scope.PA.isProcessing = false;
					$scope.createModal.hide();
				});
		};

		function makeDateString() {
			return $scope.showingDate.YYYY + "-" + $scope.showingDate.MM + "-" + $scope.showingDate.DD;
		}

		function makeDateStringV2() {
			return $scope.showingDate.YYYY + "/" + $scope.showingDate.MM + "/" + $scope.showingDate.DD;
		}

		/**
		 * Clear the warning as soon as a real address is selected. The warning is only ever raised
		 * on submit, so that an untouched form does not open with an error already showing.
		 */
		$scope.$watch(
			"display.address",
			function () {
				if (isSelectedAddress($scope.display.address)) {
					$scope.addressError = false;
				}
			},
			true
		);

		//reload search result
		$scope.$watch(
			"$ctrl.reload",
			function (newValue) {
				if (newValue && $scope.formData.YYYY && $scope.formData.MM &&
					$scope.formData.DD && $scope.formData.lastName) {
					$timeout(function () {
						angular.element(document.querySelector("#submit2")).trigger("click");
					}, 0);

				}
			},
			true
		);



		// $scope.autocompleteOptions = {
		// 	componentRestrictions: { country: "nz" },
		// 	types: ["geocode"],
		// };

		$scope.removeEmptyStringValues = function () {
			// Once text is entered and deleted into the phoneNumber, mobileNumber and email fields the value is set to an empty string.
			// Backend requires these values to pass the regex or be null
			if ($scope.CP.patient.phoneNumber === "") {
				$scope.CP.patient.phoneNumber = null;
			}
			if ($scope.CP.patient.mobileNumber === "") {
				$scope.CP.patient.mobileNumber = null;
			}
			if ($scope.CP.patient.email === "") {
				$scope.CP.patient.email = null;
			}
		};

		// This function name - startAgain(), can not be changed as it is called from the modal
		// template in two controllers(this one and examinationController).
		$scope.startAgain = function () {
			$scope.traceSuccessModal.hide();
			$scope.CP.clearPatient();
			$scope.CR.clearReferral();
			$scope.resetSearch();

			$timeout(function () {
				document.querySelector("#lastName").focus();
			}, 200);
		};

		$scope.formatDate = function (_date) {
			if (_date) {
				const date = new Date(_date);
				return date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
			}
			return "";
		}

		$scope.isFavouritePatient = function (patient) {
			return $scope.favoritePatientList.some(t => t.patientId === patient.id);
		}

		$scope.addOrRemovePatient = function (patient, isAdd) {
			if (isAdd) {
				$scope.PA.addToFavourite(patient.id)
					.then(
						function (resp) {
							if ($scope.PA.isFavouriteResponseSuccess(resp.status)) {
								$scope.Session.user.features.favoritePatientsFeature.push({
									patientId: patient.id,
									patientName: patient.firstName + ' ' + patient.lastName,
								});
								$scope.favoritePatientList = $scope.Session.user.features.favoritePatientsFeature;
								$rootScope.$broadcast('favoritePatientsChanged');
							}
						},
						function (err) {
							console.log(err && err.status);
						}
					)
					.then(function () {
						$scope.PA.isProcessing = false;
					});
			} else {
				$scope.PA.removeFavourite(patient.id)
					.then(
						function (resp) {
							if ($scope.PA.isFavouriteResponseSuccess(resp.status)) {
								$scope.Session.user.features.favoritePatientsFeature =
									$scope.Session.user.features.favoritePatientsFeature.filter(t => t.patientId !== patient.id);
								$scope.favoritePatientList = $scope.Session.user.features.favoritePatientsFeature;
								$rootScope.$broadcast('favoritePatientsChanged');
							}
						},
						function (err) {
							console.log(err && err.status);
						}
					)
					.then(function () {
						$scope.PA.isProcessing = false;
					});
			}
		}

	},
]);